<template>
     <div>
      <h1>{{ $t('help.ISASensorEnabledHelp_title') }}</h1>
      <p class="text-justify">
          {{ $('By clicking this button, you\'ll enable or disable the sensor.')}}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
